import kaplay from "kaplay";
// import "kaplay/global"; // A utiliser si vous préférez les globals sans préfixe k.

const k = kaplay({
  background: "#05021a",
});

k.setGravity(0);

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const SPEED = 140;
const ARENA_PADDING = 12;
const PLAYER_MAX_HP = 6;
const PUNCH_COOLDOWN = 0.15;
const SPECIAL_COOLDOWN = 2.4;
const SPECIAL_DAMAGE = 3;
const SPECIAL_KNOCKBACK = 120;
const BASE_ENEMY_HP = 3;
const ENEMY_SPEED = 85;
const ENEMY_ATTACK_COOLDOWN = 1.3;
const ENEMY_PUNCH_RANGE = 34;
const SCORE_PER_ENEMY = 100;
const COOLDOWN_BAR_WIDTH = 132;
const HUD_MARGIN = 20;
const HUD_HEIGHT = 150;
const HUD_SECTION_OFFSET = 200;
const HP_BAR_WIDTH = 200;
const HP_BAR_HEIGHT = 10;
const BASE_DAMAGE = 1;
const CHARGED_DAMAGE = 3;
const CHARGE_TIME = 0.55;
const CHARGED_COOLDOWN = 0.6;
const COMBO_RESET_TIME = 3;
const COMBO_BONUS = 0.15;
const BACKDROP_WIDTH = 2912;
const BACKDROP_HEIGHT = 1632;

k.loadSprite("player-avatar", "sprites/player.png", {
  sliceX: 8,
  anims: {
    idle: { from: 0, to: 3, speed: 7, loop: true },
    punch: { from: 4, to: 5, speed: 14, loop: false },
    charged: { from: 6, to: 6, speed: 1, loop: false },
    hurt: { from: 7, to: 7, speed: 1, loop: false },
  },
});

k.loadSprite("foe-avatar", "sprites/enemy.png", {
  sliceX: 8,
  anims: {
    idle: { from: 0, to: 3, speed: 6, loop: true },
    punch: { from: 4, to: 5, speed: 11, loop: false },
    charged: { from: 6, to: 6, speed: 1, loop: false },
    hurt: { from: 7, to: 7, speed: 1, loop: false },
  },
});

k.loadSound("sfx_punch", "audio/punch.wav");
k.loadSound("sfx_hurt", "audio/hurt.wav");
k.loadSound("sfx_combo", "audio/deck_ui_toast.wav");
k.loadSound("sfx_charge", "audio/deck_ui_slider_up.wav");
k.loadSound("sfx_break", "audio/deck_ui_hide_modal.wav");
k.loadSound("sfx_start", "audio/deck_ui_launch_game.wav");
k.loadSound("sfx_menu", "audio/menu.wav");
k.loadSound("bg_theme", "audio/music_zapsplat_game_music_action_fast_euro_house_pumping_fun_arcade_rave_024.mp3");
k.loadSprite("background-space", "sprites/aiwon.23_perfect_wallpaper_for_laptop_with_discret_shadows_and__05ebe6b4-d29e-4460-8e19-3b669ba224ac.png");
k.loadSprite("player-portrait", "sprites/player_portrait.png");
k.loadSprite("enemy-portrait", "sprites/enemy_portrait.png");
k.loadSprite("vignette", "sprites/vignette.png");

let menuActive = true;
let menuShade = null;
let menuTitle = null;
let menuSubtitle = null;
let menuHint = null;
let wave = 1;
let score = 0;
let currentEnemy = null;
let gameOver = false;
let bgMusicController = null;
let comboCount = 0;
let comboTimer = 0;
let isCharging = false;
let chargeStart = 0;
let chargeAura = null;
let chargeReady = false;
let lastDashSmokeTime = 0;

const player = k.add([
  k.sprite("player-avatar", { anim: "idle" }),
  k.pos(k.width() * 0.3, k.height() * 0.6),
  k.anchor("center"),
  k.area(),
  k.body(),
  k.scale(1.65),
  k.z(5),
  {
    hp: PLAYER_MAX_HP,
    canPunch: true,
    cooldownTimer: 0,
    specialReady: true,
    specialCooldownTimer: 0,
  },
  "player",
]);
player.hidden = menuActive;

const playerShadow = k.add([
  k.rect(54, 18, { radius: 9 }),
  k.pos(player.pos.x, player.pos.y + 20),
  k.anchor("center"),
  k.color(0, 0, 0),
  k.opacity(0.28),
  k.z(4),
]);
playerShadow.hidden = menuActive;

const arenaPad = ARENA_PADDING + 22;

const background = k.add([
  k.sprite("background-space"),
  k.pos(k.width() / 2, k.height() / 2),
  k.anchor("center"),
  k.fixed(),
  k.z(-120),
]);

const vignette = k.add([
  k.sprite("vignette"),
  k.pos(k.width() / 2, k.height() / 2),
  k.anchor("center"),
  k.fixed(),
  k.z(60),
  k.opacity(0.55),
]);

const arenaFloor = k.add([
  k.rect(k.width() - arenaPad * 2, k.height() * 0.55, { radius: 32 }),
  k.pos(arenaPad, k.height() * 0.38),
  k.anchor("topleft"),
  k.color(30, 20, 70),
  k.opacity(0.35),
  k.z(-50),
]);

const arenaGlow = k.add([
  k.rect(k.width() - arenaPad * 2, 14, { radius: 7 }),
  k.pos(arenaPad, k.height() * 0.38 - 18),
  k.anchor("topleft"),
  k.color(80, 120, 255),
  k.opacity(0.25),
  k.z(-40),
]);

const hudGlowBack = k.add([
  k.rect(k.width() - HUD_MARGIN * 2 + 12, HUD_HEIGHT + 18, { radius: 28 }),
  k.pos(HUD_MARGIN - 6, HUD_MARGIN - 9),
  k.fixed(),
  k.color(35, 15, 70),
  k.opacity(0.35),
  k.z(79),
]);

const hudPanel = k.add([
  k.rect(k.width() - HUD_MARGIN * 2, HUD_HEIGHT, { radius: 24 }),
  k.pos(HUD_MARGIN, HUD_MARGIN),
  k.fixed(),
  k.color(16, 10, 42),
  k.opacity(0.92),
  k.outline(3, k.rgb(84, 88, 190)),
  k.z(80),
]);

const hudTopLine = k.add([
  k.rect(k.width() - HUD_MARGIN * 2, 6, { radius: 3 }),
  k.pos(HUD_MARGIN, HUD_MARGIN + 8),
  k.fixed(),
  k.color(130, 100, 255),
  k.opacity(0.4),
  k.z(84),
]);

const hudAccent = k.add([
  k.rect(k.width() - HUD_MARGIN * 2, 4, { radius: 2 }),
  k.pos(HUD_MARGIN, HUD_MARGIN + HUD_HEIGHT - 10),
  k.fixed(),
  k.color(255, 140, 120),
  k.opacity(0.55),
  k.z(85),
]);

const hudDivider = k.add([
  k.rect(2, HUD_HEIGHT - 36, { radius: 1 }),
  k.pos(k.width() / 2, HUD_MARGIN + 18),
  k.fixed(),
  k.color(70, 62, 130),
  k.opacity(0.35),
  k.z(88),
]);

const playerPortrait = k.add([
  k.sprite("player-portrait"),
  k.pos(HUD_MARGIN + 56, HUD_MARGIN + 64),
  k.anchor("center"),
  k.scale(1.2),
  k.fixed(),
  k.z(90),
  k.opacity(1),
]);

const enemyPortrait = k.add([
  k.sprite("enemy-portrait"),
  k.pos(k.width() - HUD_MARGIN - 56, HUD_MARGIN + 64),
  k.anchor("center"),
  k.scale(1.2),
  k.fixed(),
  k.z(90),
  k.opacity(1),
]);

let playerFacing = k.vec2(1, 0);

const getFacingDirection = () => {
  const len = Math.hypot(playerFacing.x, playerFacing.y);
  if (len === 0) {
    return k.vec2(1, 0);
  }
  return k.vec2(playerFacing.x / len, playerFacing.y / len);
};

player.onUpdate(() => {
  if (menuActive) return;
  const halfW = (player.width ?? 32) / 2;
  const halfH = (player.height ?? 32) / 2;
  const minX = arenaPad + halfW;
  const maxX = k.width() - arenaPad - halfW;
  const minY = HUD_HEIGHT + 30 + halfH;
  const maxY = k.height() - ARENA_PADDING - halfH;

  player.pos.x = clamp(player.pos.x, minX, maxX);
  player.pos.y = clamp(player.pos.y, minY, maxY);
  playerShadow.pos = k.vec2(player.pos.x, player.pos.y + 20);
});

const playerHpLabel = k.add([
  k.text(`PV Joueur : ${PLAYER_MAX_HP}`, {
    size: 26,
    font: "sink",
  }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 20),
  k.anchor("left"),
  k.fixed(),
  k.color(190, 225, 255),
  k.z(90),
]);

const enemyHpLabel = k.add([
  k.text("PV Ennemi : --", {
    size: 26,
    font: "sink",
  }),
  k.pos(k.width() - HUD_MARGIN - 120, HUD_MARGIN + 20),
  k.anchor("right"),
  k.fixed(),
  k.color(255, 170, 180),
  k.z(90),
]);

const waveLabel = k.add([
  k.text("Manche : 1", {
    size: 22,
    font: "sink",
  }),
  k.pos(k.width() / 2, HUD_MARGIN + 18),
  k.anchor("center"),
  k.fixed(),
  k.color(198, 225, 255),
  k.z(90),
]);

const scoreLabel = k.add([
  k.text("Score : 0", {
    size: 22,
    font: "sink",
  }),
  k.pos(k.width() / 2, HUD_MARGIN + 44),
  k.anchor("center"),
  k.fixed(),
  k.color(182, 255, 212),
  k.z(90),
]);

const comboLabel = k.add([
  k.text("", { size: 22, font: "sink" }),
  k.pos(k.width() / 2, HUD_MARGIN + 70),
  k.anchor("center"),
  k.fixed(),
  k.color(255, 210, 130),
  k.z(90),
  k.opacity(0.9),
]);
comboLabel.hidden = true;

const playerHpBarBg = k.add([
  k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, { radius: 5 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 34),
  k.anchor("left"),
  k.fixed(),
  k.color(40, 40, 80),
  k.opacity(0.6),
  k.z(88),
]);

const playerHpBarFill = k.add([
  k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, { radius: 5 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 34),
  k.anchor("left"),
  k.fixed(),
  k.color(90, 220, 255),
  k.z(89),
]);

const enemyHpBarBg = k.add([
  k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, { radius: 5 }),
  k.pos(k.width() - HUD_MARGIN - HP_BAR_WIDTH, HUD_MARGIN + 34),
  k.anchor("left"),
  k.fixed(),
  k.color(60, 30, 70),
  k.opacity(0.6),
  k.z(88),
]);

const enemyHpBarFill = k.add([
  k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, { radius: 5 }),
  k.pos(k.width() - HUD_MARGIN - HP_BAR_WIDTH, HUD_MARGIN + 34),
  k.anchor("left"),
  k.fixed(),
  k.color(255, 110, 140),
  k.z(89),
]);

const cooldownText = k.add([
  k.text("Coup prêt", {
    size: 20,
    font: "sink",
  }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 44),
  k.anchor("left"),
  k.fixed(),
  k.color(190, 210, 255),
  k.z(90),
]);

const cooldownBg = k.add([
  k.rect(COOLDOWN_BAR_WIDTH, 12, { radius: 6 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 62),
  k.fixed(),
  k.color(40, 52, 110),
  k.opacity(0.7),
  k.anchor("topleft"),
  k.z(90),
]);

const cooldownFill = k.add([
  k.rect(COOLDOWN_BAR_WIDTH, 12, { radius: 6 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 62),
  k.fixed(),
  k.color(110, 205, 255),
  k.anchor("topleft"),
  k.scale(1, 1),
  k.z(91),
]);

const specialText = k.add([
  k.text("Attaque Spéciale", {
    size: 20,
    font: "sink",
  }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 88),
  k.anchor("left"),
  k.fixed(),
  k.color(255, 200, 170),
  k.z(90),
]);

const specialBg = k.add([
  k.rect(COOLDOWN_BAR_WIDTH, 12, { radius: 6 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 92),
  k.fixed(),
  k.color(80, 40, 110),
  k.opacity(0.6),
  k.anchor("topleft"),
  k.z(90),
]);

const specialFill = k.add([
  k.rect(COOLDOWN_BAR_WIDTH, 12, { radius: 6 }),
  k.pos(HUD_MARGIN + 120, HUD_MARGIN + 92),
  k.fixed(),
  k.color(255, 156, 120),
  k.anchor("topleft"),
  k.scale(1, 1),
  k.z(91),
]);

const resizeBackground = () => {
  if (!background.exists()) return;
  const scale = Math.max(k.width() / BACKDROP_WIDTH, k.height() / BACKDROP_HEIGHT);
  background.scale = k.vec2(scale, scale);
  background.pos = k.vec2(k.width() / 2, k.height() / 2);
  if (vignette.exists()) {
    const vw = vignette.width || 1;
    const vh = vignette.height || 1;
    const vScale = Math.max(k.width() / vw, k.height() / vh);
    vignette.scale = k.vec2(vScale, vScale);
    vignette.pos = k.vec2(k.width() / 2, k.height() / 2);
  }
};

const layoutUI = () => {
  const width = k.width();
  const height = k.height();
  const panelWidth = Math.max(520, width - HUD_MARGIN * 2);
  const portraitY = HUD_MARGIN + HUD_HEIGHT / 2;
  const centerX = width / 2;
  const leftTextX = HUD_MARGIN + 120;
  const rightTextX = width - HUD_MARGIN - 120;

  resizeBackground();

  hudGlowBack.width = panelWidth + 12;
  hudGlowBack.height = HUD_HEIGHT + 18;
  hudGlowBack.pos = k.vec2(HUD_MARGIN - 6, HUD_MARGIN - 9);

  hudPanel.width = panelWidth;
  hudPanel.height = HUD_HEIGHT;
  hudPanel.pos = k.vec2(HUD_MARGIN, HUD_MARGIN);

  hudTopLine.width = panelWidth;
  hudTopLine.pos = k.vec2(HUD_MARGIN, HUD_MARGIN + 8);

  hudAccent.width = panelWidth;
  hudAccent.pos = k.vec2(HUD_MARGIN, HUD_MARGIN + HUD_HEIGHT - 12);

  hudDivider.height = HUD_HEIGHT - 36;
  hudDivider.pos = k.vec2(centerX, HUD_MARGIN + 18);

  playerPortrait.pos = k.vec2(HUD_MARGIN + 60, portraitY);
  enemyPortrait.pos = k.vec2(width - HUD_MARGIN - 60, portraitY);

  playerHpLabel.pos = k.vec2(leftTextX, HUD_MARGIN + 18);
  enemyHpLabel.pos = k.vec2(rightTextX, HUD_MARGIN + 18);
  cooldownText.pos = k.vec2(leftTextX, HUD_MARGIN + 46);
  cooldownBg.pos = k.vec2(leftTextX, HUD_MARGIN + 60);
  cooldownFill.pos = k.vec2(leftTextX, HUD_MARGIN + 60);
  cooldownBg.width = COOLDOWN_BAR_WIDTH;
  cooldownFill.width = COOLDOWN_BAR_WIDTH;
  specialText.pos = k.vec2(leftTextX, HUD_MARGIN + 82);
  specialBg.pos = k.vec2(leftTextX, HUD_MARGIN + 96);
  specialFill.pos = k.vec2(leftTextX, HUD_MARGIN + 96);
  specialBg.width = COOLDOWN_BAR_WIDTH;
  specialFill.width = COOLDOWN_BAR_WIDTH;

  waveLabel.pos = k.vec2(centerX, HUD_MARGIN + 18);
  scoreLabel.pos = k.vec2(centerX, HUD_MARGIN + 44);
  comboLabel.pos = k.vec2(centerX, HUD_MARGIN + 70);
  playerHpBarBg.pos = k.vec2(leftTextX, HUD_MARGIN + 32);
  playerHpBarFill.pos = k.vec2(leftTextX, HUD_MARGIN + 32);
  const enemyBarX = rightTextX - HP_BAR_WIDTH;
  enemyHpBarBg.pos = k.vec2(enemyBarX, HUD_MARGIN + 32);
  enemyHpBarFill.pos = k.vec2(enemyBarX, HUD_MARGIN + 32);

  const floorWidth = Math.max(360, width - arenaPad * 2);
  const floorTop = Math.max(HUD_HEIGHT + 40, height * 0.4);
  const floorHeight = Math.max(220, height - floorTop - ARENA_PADDING);

  arenaFloor.width = floorWidth;
  arenaFloor.height = floorHeight;
  arenaFloor.pos = k.vec2(arenaPad, floorTop);

  arenaGlow.width = floorWidth;
  arenaGlow.pos = k.vec2(arenaPad, floorTop - 20);

  if (menuShade?.exists()) {
    menuShade.width = width;
    menuShade.height = height;
    menuShade.pos = k.vec2(0, 0);
  }

  if (menuTitle?.exists()) {
    menuTitle.pos = k.vec2(width / 2, height / 2 - 60);
  }

  if (menuSubtitle?.exists()) {
    menuSubtitle.pos = k.vec2(width / 2, height / 2 - 6);
  }

  if (menuHint?.exists()) {
    menuHint.pos = k.vec2(width / 2, height / 2 + 52);
  }
};

layoutUI();
k.onResize(layoutUI);



const updatePlayerHpLabel = () => {
  playerHpLabel.text = `PV Joueur : ${player.hp}`;
  updateHealthBars();
};

const updateEnemyHpLabel = () => {
  if (currentEnemy && currentEnemy.exists()) {
    enemyHpLabel.text = `PV Ennemi : ${currentEnemy.hp}`;
  } else {
    enemyHpLabel.text = "PV Ennemi : --";
  }
  updateHealthBars();
};

const updateWaveLabel = () => {
  waveLabel.text = `Manche : ${wave}`;
};

const updateScoreLabel = () => {
  scoreLabel.text = `Score : ${score}`;
};

const updateCooldownUI = () => {
  const progress = player.canPunch
    ? 1
    : clamp(1 - player.cooldownTimer / PUNCH_COOLDOWN, 0, 1);
  cooldownFill.scale.x = progress;
  if (progress >= 1) {
    cooldownText.text = "Coup prêt";
  } else {
    const seconds = Math.max(0, player.cooldownTimer);
    cooldownText.text = `Recharge ${seconds.toFixed(2)}s`;
  }
};

const updateSpecialCooldownUI = () => {
  const progress = player.specialReady
    ? 1
    : clamp(1 - player.specialCooldownTimer / SPECIAL_COOLDOWN, 0, 1);
  specialFill.scale.x = progress;
  if (progress >= 1) {
    specialText.text = "Attaque Spéciale";
  } else {
    specialText.text = `Spéciale ${player.specialCooldownTimer.toFixed(1)}s`;
  }
};

const getComboMultiplier = () => Math.min(1 + comboCount * COMBO_BONUS, 3);

const updateHealthBars = () => {
  const playerRatio = clamp(player.hp / PLAYER_MAX_HP, 0, 1);
  playerHpBarFill.width = HP_BAR_WIDTH * playerRatio;
  const enemyExists = currentEnemy && currentEnemy.exists();
  const enemyHP = enemyExists ? currentEnemy.hp : 0;
  const enemyMax = enemyExists ? currentEnemy.maxHp ?? BASE_ENEMY_HP : BASE_ENEMY_HP;
  const enemyRatio = clamp(enemyHP / Math.max(1, enemyMax), 0, 1);
  enemyHpBarFill.width = HP_BAR_WIDTH * enemyRatio;
};

const updateComboLabel = () => {
  if (comboCount > 0 && !menuActive) {
    comboLabel.hidden = false;
    comboLabel.text = `Combo x${comboCount}`;
    const intensity = clamp(comboCount * 0.2, 0, 1);
    comboLabel.color = k.rgb(
      Math.floor(255 * (0.8 + 0.2 * intensity)),
      Math.floor(180 + 40 * intensity),
      Math.floor(120 + 80 * intensity)
    );
  } else {
    comboLabel.hidden = true;
  }
};

const resetCombo = () => {
  if (comboCount === 0) return;
  if (comboCount >= 3) {
    k.play("sfx_break", { volume: 0.45 });
  }
  comboCount = 0;
  comboTimer = 0;
  updateComboLabel();
};

const registerCombo = () => {
  comboCount += 1;
  comboTimer = COMBO_RESET_TIME;
  updateComboLabel();
  if (comboCount > 1) {
    k.play("sfx_combo", { volume: 0.4 + Math.min(0.4, comboCount * 0.05) });
  }
};

const resetPlayerState = () => {
  player.hp = PLAYER_MAX_HP;
  player.canPunch = true;
  player.cooldownTimer = 0;
  player.specialReady = true;
  player.specialCooldownTimer = 0;
  const halfW = (player.width ?? 32) / 2;
  const halfH = (player.height ?? 32) / 2;
  const minX = arenaPad + halfW;
  const maxX = k.width() - arenaPad - halfW;
  const minY = HUD_HEIGHT + 30 + halfH;
  const maxY = k.height() - ARENA_PADDING - halfH;
  const spawnX = clamp(k.width() * 0.28, minX, maxX);
  const spawnY = clamp(k.height() * 0.65, minY, maxY);
  player.pos = k.vec2(spawnX, spawnY);
  playerShadow.pos = k.vec2(player.pos.x, player.pos.y + 20);
  player.hidden = menuActive;
  playerShadow.hidden = menuActive;
  playerFacing = k.vec2(1, 0);
  updatePlayerHpLabel();
  updateCooldownUI();
  updateSpecialCooldownUI();
  if (player.exists()) {
    player.play("idle");
  }
  resetCombo();
};

const spawnSlashParticles = (origin, facing, tint = k.rgb(150, 220, 255)) => {
  const dir = facing.len() > 0 ? facing.unit() : k.vec2(1, 0);
  for (let i = 0; i < 6; i++) {
    const jitter = k.vec2((Math.random() - 0.5) * 12, (Math.random() - 0.5) * 8);
    const spark = k.add([
      k.pos(origin.add(jitter.scale(0.25))),
      k.rect(6, 2, { radius: 1 }),
      k.color(tint.r, tint.g, tint.b),
      k.opacity(1),
      k.lifespan(0.3, { fade: 0.15 }),
      { vel: dir.scale(220 + Math.random() * 140).add(jitter.scale(8)) },
    ]);

    spark.onUpdate(() => {
      spark.pos = spark.pos.add(spark.vel.scale(k.dt()));
      spark.vel = spark.vel.scale(0.88);
    });
  }
};

const spawnImpactBurst = (origin, tint = k.rgb(255, 150, 110)) => {
  for (let i = 0; i < 8; i++) {
    const angle = Math.random() * Math.PI * 2;
    const speed = 120 + Math.random() * 160;
    const vel = k.vec2(Math.cos(angle), Math.sin(angle)).scale(speed);
    const particle = k.add([
      k.pos(origin),
      k.rect(4, 4, { radius: 2 }),
      k.color(tint.r, tint.g, tint.b),
      k.opacity(1),
      k.lifespan(0.35, { fade: 0.2 }),
      { vel },
    ]);

    particle.onUpdate(() => {
      particle.pos = particle.pos.add(particle.vel.scale(k.dt()));
      particle.vel = particle.vel.scale(0.9);
    });
  }
};

const spawnDashSmoke = (origin, dir) => {
  if (menuActive || gameOver) return;
  const now = performance.now();
  if (now - lastDashSmokeTime < 90) return;
  lastDashSmokeTime = now;
  const puff = k.add([
    k.pos(origin.add(dir.scale(-6))),
    k.rect(10, 6, { radius: 3 }),
    k.color(60, 80, 120),
    k.opacity(0.4),
    k.lifespan(0.35, { fade: 0.3 }),
    { vel: dir.scale(-60).add(k.vec2((Math.random() - 0.5) * 50, (Math.random() - 0.5) * 30)) },
  ]);

  puff.onUpdate(() => {
    puff.pos = puff.pos.add(puff.vel.scale(k.dt()));
    puff.vel = puff.vel.scale(0.9);
  });
};

const spawnParrySparks = (origin) => {
  for (let i = 0; i < 12; i++) {
    const angle = (Math.PI * 2 * i) / 12 + Math.random() * 0.3;
    const vel = k.vec2(Math.cos(angle), Math.sin(angle)).scale(120 + Math.random() * 80);
    const spark = k.add([
      k.pos(origin),
      k.rect(3, 2, { radius: 1 }),
      k.color(255, 220, 150),
      k.opacity(1),
      k.lifespan(0.25, { fade: 0.12 }),
      { vel },
    ]);

    spark.onUpdate(() => {
      spark.pos = spark.pos.add(spark.vel.scale(k.dt()));
      spark.vel = spark.vel.scale(0.82);
    });
  }
};

const cleanupChargeAura = () => {
  if (chargeAura && chargeAura.exists()) {
    k.destroy(chargeAura);
  }
  chargeAura = null;
  isCharging = false;
  chargeReady = false;
};

const destroyMenuOverlay = () => {
  [menuShade, menuTitle, menuSubtitle, menuHint].forEach((el) => {
    if (el?.exists()) k.destroy(el);
  });
};

const showStartMenu = () => {
  menuActive = true;
  if (bgMusicController) {
    bgMusicController.stop();
    bgMusicController = null;
  }
  resetCombo();
  cleanupChargeAura();
  destroyMenuOverlay();
  menuShade = k.add([
    k.rect(k.width(), k.height()),
    k.pos(0, 0),
    k.anchor("topleft"),
    k.color(4, 6, 16),
    k.opacity(0.82),
    k.fixed(),
    k.z(120),
  ]);

  menuTitle = k.add([
    k.text("One-Fight", { size: 44, font: "sink" }),
    k.pos(k.width() / 2, k.height() / 2 - 60),
    k.anchor("center"),
    k.color(200, 230, 255),
    k.fixed(),
    k.z(121),
  ]);

  menuSubtitle = k.add([
    k.text("Appuie sur Entrée pour démarrer", { size: 22, font: "sink" }),
    k.pos(k.width() / 2, k.height() / 2 - 6),
    k.anchor("center"),
    k.color(180, 200, 255),
    k.fixed(),
    k.z(121),
  ]);

  menuHint = k.add([
    k.text("Déplacement : flèches  •  Coup : Espace  •  Spéciale : F", { size: 18, font: "sink" }),
    k.pos(k.width() / 2, k.height() / 2 + 52),
    k.anchor("center"),
    k.color(140, 160, 220),
    k.fixed(),
    k.z(121),
  ]);

  k.play("sfx_menu", { volume: 0.6 });
};

const beginFight = () => {
  if (!menuActive) return;
  menuActive = false;
  destroyMenuOverlay();
  player.hidden = false;
  playerShadow.hidden = false;
  resetPlayerState();
  player.play("idle");
  k.play("sfx_start", { volume: 0.7 });
  if (!bgMusicController || bgMusicController.stopped) {
    bgMusicController = k.play("bg_theme", { volume: 0.55, loop: true });
  }
  cleanupChargeAura();
  spawnEnemy();
};

const enemyPunch = (foe) => {
  if (!foe.exists()) return;

  const dir = player.pos.sub(foe.pos);
  const base = dir.len() > 0 ? dir.unit() : k.vec2(1, 0);
  if (!foe.isDefeated) {
    foe.play("punch");
    k.wait(0.28, () => {
      if (foe.exists() && !foe.isDefeated) {
        foe.play("idle");
      }
    });
  }
  k.play("sfx_punch", { volume: 0.45 });
  const hit = k.add([
    k.rect(14, 10),
    k.area(),
    k.pos(foe.pos.add(base.scale(18))),
    k.opacity(1),
    k.lifespan(0.14, { fade: 0.05 }),
    k.color(255, 190, 160),
    "foePunch",
  ]);

  hit.onCollide("player", () => {
    damagePlayer(1);
    spawnImpactBurst(player.pos.add(base.scale(-4)), k.rgb(255, 120, 90));
  });
};

const spawnEnemy = () => {
  if (gameOver || menuActive) return;

  const foeHp = BASE_ENEMY_HP + (wave - 1);
  const foe = k.add([
    k.sprite("foe-avatar", { anim: "idle" }),
    k.pos(k.width() * 0.7, k.height() * 0.6),
    k.anchor("center"),
    k.area(),
    k.scale(1.6),
    k.z(5),
    {
      hp: foeHp,
      maxHp: foeHp,
      attackTimer: ENEMY_ATTACK_COOLDOWN * 0.5,
      isDefeated: false,
    },
    "foe",
  ]);

  const foeHalfW = (foe.width ?? 32) / 2;
  const foeHalfH = (foe.height ?? 32) / 2;
  const foeMinX = arenaPad + foeHalfW;
  const foeMaxX = k.width() - arenaPad - foeHalfW;
  const foeMinY = HUD_HEIGHT + 30 + foeHalfH;
  const foeMaxY = k.height() - ARENA_PADDING - foeHalfH;
  const foeSpawnX = clamp(k.width() * 0.72, foeMinX, foeMaxX);
  const foeSpawnY = clamp(k.height() * 0.6, foeMinY, foeMaxY);
  foe.pos = k.vec2(foeSpawnX, foeSpawnY);
  foe.play("idle");

  const foeShadow = k.add([
    k.rect(52, 18, { radius: 9 }),
    k.pos(foe.pos.x, foe.pos.y + 20),
    k.anchor("center"),
    k.color(0, 0, 0),
    k.opacity(0.22),
    k.z(4),
  ]);

  foe.onUpdate(() => {
    if (!player.exists() || foe.isDefeated || menuActive) return;

    const dir = player.pos.sub(foe.pos);
    const distance = dir.len();

    if (distance > 1) {
      const movement = dir.unit().scale(ENEMY_SPEED * k.dt());
      foe.pos = foe.pos.add(movement);
    }

    const halfW = (foe.width ?? 32) / 2;
    const halfH = (foe.height ?? 32) / 2;
    const minX = arenaPad + halfW;
    const maxX = k.width() - arenaPad - halfW;
    const minY = HUD_HEIGHT + 30 + halfH;
    const maxY = k.height() - ARENA_PADDING - halfH;

    foe.pos.x = clamp(foe.pos.x, minX, maxX);
    foe.pos.y = clamp(foe.pos.y, minY, maxY);
    foeShadow.pos = k.vec2(foe.pos.x, foe.pos.y + 20);

    foe.attackTimer -= k.dt();

    if (foe.attackTimer <= 0 && distance <= ENEMY_PUNCH_RANGE) {
      foe.attackTimer = ENEMY_ATTACK_COOLDOWN;
      enemyPunch(foe);
    }
  });

  foe.onDestroy(() => {
    if (currentEnemy === foe) {
      currentEnemy = null;
      updateEnemyHpLabel();
    }
    if (foeShadow.exists()) {
      k.destroy(foeShadow);
    }
  });

  currentEnemy = foe;
  updateEnemyHpLabel();
  return foe;
};

const endEnemy = (foe) => {
  if (!foe.exists() || foe.isDefeated) return;
  foe.isDefeated = true;
  k.destroy(foe);
};

const queueNextWave = () => {
  k.wait(0.8, () => {
    if (!gameOver && !menuActive) {
      spawnEnemy();
    }
  });
};

const damageEnemy = (foe, amount = 1) => {
  if (!foe.exists() || foe.isDefeated) return;

  const multiplier = getComboMultiplier();
  const finalAmount = Math.max(1, Math.round(amount * multiplier));

  foe.hp = Math.max(0, foe.hp - finalAmount);
  updateEnemyHpLabel();
  k.shake(2);
  if (!foe.isDefeated) {
    foe.play("hurt");
    k.wait(0.3, () => {
      if (foe.exists() && !foe.isDefeated) {
        foe.play("idle");
      }
    });
  }
  spawnImpactBurst(foe.pos, k.rgb(255, 170, 120));
  k.play("sfx_punch", { volume: 0.55 });

  if (foe.hp <= 0) {
    endEnemy(foe);
    score += SCORE_PER_ENEMY;
    wave += 1;
    const bonus = k.add([
      k.text(`+${SCORE_PER_ENEMY}`, {
        size: 20,
        font: "arcade",
      }),
      k.pos(k.vec2(foe.pos)),
      k.anchor("center"),
      k.color(180, 255, 210),
      k.outline(2, k.rgb(30, 80, 60)),
      k.opacity(1),
      k.z(40),
      k.lifespan(0.6, { fade: 0.2 }),
    ]);

    bonus.onUpdate(() => {
      bonus.pos = bonus.pos.add(k.vec2(0, -60 * k.dt()));
    });

    updateScoreLabel();
    updateWaveLabel();
    queueNextWave();
  }
};

const damagePlayer = (amount = 1) => {
  if (gameOver) return;

  player.hp = Math.max(0, player.hp - amount);
  updatePlayerHpLabel();
  k.shake(4);
  player.play("hurt");
  k.play("sfx_hurt", { volume: 0.6 });
  spawnParrySparks(player.pos);
  resetCombo();
  cleanupChargeAura();
  k.wait(0.35, () => {
    if (!gameOver && player.exists()) {
      player.play("idle");
    }
  });

  if (player.hp <= 0) {
    triggerGameOver();
  }
};

const triggerSpecialAttack = () => {
  if (gameOver || menuActive || !player.specialReady) return;

  player.specialReady = false;
  player.specialCooldownTimer = SPECIAL_COOLDOWN;
  updateSpecialCooldownUI();
  player.play("charged");
  k.wait(0.3, () => {
    if (!gameOver && player.exists()) {
      player.play("idle");
    }
  });

  const facing = getFacingDirection();
  const spawnOffset = facing.scale(22);
  spawnSlashParticles(player.pos.add(spawnOffset), facing, k.rgb(255, 210, 140));
  k.play("sfx_punch", { volume: 0.75 });
  const hit = k.add([
    k.rect(26, 18),
    k.area(),
    k.pos(player.pos.add(spawnOffset)),
    k.opacity(1),
    k.lifespan(0.18, { fade: 0.08 }),
    k.color(255, 210, 120),
    "specialPunch",
  ]);

  k.shake(6);

  let hasHit = false;

  hit.onCollide("foe", (foe) => {
    if (hasHit) return;
    hasHit = true;
    registerCombo();
    damageEnemy(foe, SPECIAL_DAMAGE);
    const knockback = facing.scale(SPECIAL_KNOCKBACK);
    foe.pos = foe.pos.add(knockback);
  });
};

const performLightAttack = () => {
  if (!player.canPunch) return;
  player.canPunch = false;
  player.cooldownTimer = PUNCH_COOLDOWN;
  updateCooldownUI();
  player.play("punch");
  k.play("sfx_punch", { volume: 0.65 });
  k.wait(0.2, () => {
    if (!gameOver && player.exists()) {
      player.play("idle");
    }
  });

  const facing = getFacingDirection();
  const offset = facing.scale(16);
  spawnSlashParticles(player.pos.add(offset), facing);

  const hit = k.add([
    k.rect(16, 12),
    k.area(),
    k.pos(player.pos.add(offset)),
    k.opacity(1),
    k.lifespan(0.12, { fade: 0.05 }),
    k.color(255, 255, 255),
    "punch",
  ]);

  let hasHit = false;

  hit.onCollide("foe", (foe) => {
    if (hasHit) return;
    hasHit = true;
    registerCombo();
    damageEnemy(foe, BASE_DAMAGE);
  });
};

const performChargedAttack = () => {
  if (!player.canPunch) return;
  player.canPunch = false;
  player.cooldownTimer = CHARGED_COOLDOWN;
  updateCooldownUI();
  player.play("punch");
  k.play("sfx_punch", { volume: 0.8 });
  k.wait(0.28, () => {
    if (!gameOver && player.exists()) {
      player.play("idle");
    }
  });

  const facing = getFacingDirection();
  const offset = facing.scale(22);
  spawnSlashParticles(player.pos.add(offset), facing, k.rgb(255, 210, 140));
  spawnImpactBurst(player.pos.add(offset.scale(0.4)), k.rgb(255, 190, 140));
  cleanupChargeAura();

  const hit = k.add([
    k.rect(24, 16),
    k.area(),
    k.pos(player.pos.add(offset)),
    k.opacity(1),
    k.lifespan(0.16, { fade: 0.08 }),
    k.color(255, 200, 150),
    "chargedPunch",
  ]);

  let hasHit = false;

  hit.onCollide("foe", (foe) => {
    if (hasHit) return;
    hasHit = true;
    registerCombo();
    damageEnemy(foe, CHARGED_DAMAGE);
    spawnParrySparks(foe.pos);
  });
};

const triggerGameOver = () => {
  if (gameOver) return;
  gameOver = true;

  if (currentEnemy && currentEnemy.exists()) {
    endEnemy(currentEnemy);
  }

  const overlay = k.add([
    k.rect(k.width() * 0.42, 120, { radius: 24 }),
    k.pos(k.width() / 2, k.height() / 2),
    k.anchor("center"),
    k.fixed(),
    k.color(20, 16, 56),
    k.opacity(0.92),
    k.z(95),
  ]);

  const message = k.add([
    k.text("KO - ENTREE POUR REJOUER", {
      size: 22,
      font: "arcade",
    }),
    k.pos(k.width() / 2, k.height() / 2),
    k.anchor("center"),
    k.fixed(),
    k.color(255, 240, 200),
    k.z(96),
  ]);

  k.wait(0.05, () => k.shake(6));

  let offEnter;

  const cleanup = () => {
    if (!gameOver) return;
    if (message.exists()) k.destroy(message);
    if (overlay.exists()) k.destroy(overlay);
    if (offEnter) {
      offEnter.cancel();
      offEnter = null;
    }
    gameOver = false;
    wave = 1;
    score = 0;
    updateWaveLabel();
    updateScoreLabel();
    resetPlayerState();
    spawnEnemy();
  };

  offEnter = k.onKeyPress("enter", () => {
    cleanup();
  });

  k.wait(2, () => {
    cleanup();
  });
};

k.onKeyDown("left", () => {
  if (menuActive || gameOver) return;
  player.move(-SPEED, 0);
  playerFacing = k.vec2(-1, 0);
  spawnDashSmoke(player.pos, k.vec2(-1, 0));
});

k.onKeyDown("right", () => {
  if (menuActive || gameOver) return;
  player.move(SPEED, 0);
  playerFacing = k.vec2(1, 0);
  spawnDashSmoke(player.pos, k.vec2(1, 0));
});

k.onKeyDown("up", () => {
  if (menuActive || gameOver) return;
  player.move(0, -SPEED);
  playerFacing = k.vec2(0, -1);
  spawnDashSmoke(player.pos, k.vec2(0, -1));
});

k.onKeyDown("down", () => {
  if (menuActive || gameOver) return;
  player.move(0, SPEED);
  playerFacing = k.vec2(0, 1);
  spawnDashSmoke(player.pos, k.vec2(0, 1));
});

k.onKeyPress("f", () => {
  if (!menuActive) {
    triggerSpecialAttack();
  }
});

k.onKeyDown("space", () => {
  if (menuActive || gameOver || !player.canPunch || isCharging) return;
  isCharging = true;
  chargeStart = performance.now() / 1000;
  chargeReady = false;
  player.play("charged");
  chargeAura = k.add([
    k.pos(player.pos),
    k.circle(28),
    k.color(120, 190, 255),
    k.opacity(0.18),
    { follow: player },
  ]);
});

k.onKeyRelease("space", () => {
  if (!isCharging) {
    cleanupChargeAura();
    return;
  }
  const held = performance.now() / 1000 - chargeStart;
  isCharging = false;
  cleanupChargeAura();

  if (menuActive || gameOver || !player.canPunch) return;

  if (held >= CHARGE_TIME) {
    performChargedAttack();
  } else {
    performLightAttack();
  }
});

k.onKeyPress("enter", () => {
  if (menuActive) {
    beginFight();
  }
});

k.onUpdate(() => {
  if (menuActive) return;
  if (!player.canPunch) {
    player.cooldownTimer -= k.dt();

    if (player.cooldownTimer <= 0) {
      player.canPunch = true;
      player.cooldownTimer = 0;
      if (player.exists()) {
        player.play("idle");
      }
    }

    updateCooldownUI();
  }

  if (!player.specialReady) {
    player.specialCooldownTimer -= k.dt();

    if (player.specialCooldownTimer <= 0) {
      player.specialReady = true;
      player.specialCooldownTimer = 0;
    }

    updateSpecialCooldownUI();
  }

  if (comboTimer > 0) {
    comboTimer -= k.dt();
    if (comboTimer <= 0) {
      resetCombo();
    }
  }

  if (chargeAura && chargeAura.exists()) {
    chargeAura.pos = player.pos;
    const elapsed = Math.max(0, performance.now() / 1000 - chargeStart);
    chargeAura.opacity = 0.18 + Math.min(0.25, elapsed * 0.5);
  }

  if (isCharging) {
    const elapsed = Math.max(0, performance.now() / 1000 - chargeStart);
    if (!chargeReady && elapsed >= CHARGE_TIME) {
      chargeReady = true;
      k.play("sfx_charge", { volume: 0.5 });
      spawnParrySparks(player.pos.add(getFacingDirection().scale(6)));
    }
  }
});

updateScoreLabel();
updateWaveLabel();
updatePlayerHpLabel();
updateEnemyHpLabel();
updateCooldownUI();
resetPlayerState();
showStartMenu();
